import { PropsWithChildren } from "react";

const Controls: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export default Controls;
